import gql from 'graphql-tag';

export const updateStudyPlanningStateMutation = gql`
  mutation updateStudyPlanningState($courseId: Int!, $canGraduateEarly: Boolean!) {
    studyPlanning: updateStudyPlanningState(courseId: $courseId) {
      id
      courseId
      contractDate
      contractExpirationDate
      listsPerWeek
      hasWeekToAnticipate
      isActive
      creationDate
      expirationDate
      currentWeek {
        id
        studyPlanningId
        position
        startDate
        endDate
        listsAndOverdueLists {
          id
          weekId
          listId
          classroomId
          isOverdue
        }
      }
      selectedBreakpoint(canGraduateEarly: $canGraduateEarly) {
        listsPerWeek
        hoursPerWeek
        totalWeeks
      }
    }
  }
`;

export const setStudyPlanningMutation = gql`
  mutation saveStudyPlanning(
    $numberOfMonths: Int!
    $descomplicaToken: String!
    $courseId: Int!
    $trial: Boolean = false
    $canGraduateEarly: Boolean
  ) {
    saveStudyPlanning(
      courseId: $courseId
      numberOfMonths: $numberOfMonths
      descomplicaToken: $descomplicaToken
      trial: $trial
      canGraduateEarly: $canGraduateEarly
    ) {
      id
      courseId
      contractDate
      contractExpirationDate
      listsPerWeek
      hasWeekToAnticipate
      isActive
      creationDate
      expirationDate
      currentWeek {
        id
        studyPlanningId
        position
        startDate
        endDate
        listsAndOverdueLists {
          id
          weekId
          listId
          classroomId
          isOverdue
        }
      }
      selectedBreakpoint {
        listsPerWeek
        hoursPerWeek
        totalWeeks
      }
    }
  }
`;

export const anticipateStudyPlanningWeekListsMutation = gql`
  mutation anticipateStudyPlanningWeekLists($studyPlanningId: Int!) {
    anticipateWeek(studyPlanningId: $studyPlanningId)
  }
`;
